export default {
  hordeEnergyToStr: '当前每点能量 +{0} 力量',
  hordeEnergyToEnergyReg: '每失去一点能量 +{0} 能量恢复',
  hordeEnergyOnCrit: '普通攻击暴击时 +{0} 能量',
  hordeHealOnCrit: '普通攻击暴击时恢复 {0} 最大生命值',
  hordeRestoreCooldownOnCrit: '普通攻击暴击时减少冷却时间 {0}',
  hordeBloodOnCrit: '普通攻击暴击时获得 {0} 敌人血液',
  hordeManaRest: '{0} 内不使用主动技能获得魔力回复 {1}',
  hordeManasteal: '击杀敌人时获得魔力 {0}',
  hordePassiveRecovery: '每秒提供 {0} 恢复',
  hordeActiveDamageCrit: '伤害类主动技 {0} 几率暴击',
  hordeActiveHealCrit: '恢复类主动技 {0} 几率暴击',
  hordeAttackAfterTime: '同一场战斗每分钟获得 +{0} 攻击力',
  hordeStrIntAfterTime: '同一场战斗中每分钟获得 {0} 力量和智力',
}
